<template>
  <b-modal ref="out-of-loans-modal" modal-class="out-of-loans-modal" size="lg" centered hide-footer>
    <div class="out-of-loans-container">
      <div class="out-of-loans-content">
        <h3>Running Low on Loans</h3>
        <p>We recently launched and it looks like demand is higher than expected!</p>
        <p>As a result, at the moment there may be no available loans on Income marketplace.</p>
        <p>We are working on listing loans for you to invest in. If you didnt find any loans to invest in we suggest you check again in a day or two or  to set up an autoinvest strategy to catch eligible loans when they become available.</p>
        <p>Thank you for your understanding.</p>
      </div>
      <div class="out-of-loans-icon">
        <img :src="this.getSrc('empty.svg')" alt="">
      </div>
    </div>
  </b-modal>
</template>

<script>
import imageMixin from '@/mixins/image'
export default {
  name: 'OutOfLoansModal',
  props: ['enabled'],
  mixins: [imageMixin],
  watch: {
    enabled: function (val)
    {
      const showCookieAlert = !this.$cookie.get('outOfLoansModal')
      if (val === true && showCookieAlert)
      {
        this.$cookie.set('outOfLoansModal', true, 1)
        this.$refs['out-of-loans-modal'].show()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  h3 {
    margin-bottom: 24px;
    font-size: 36px;
    font-weight: 600;
    color: #EC4C60;
  }
  p {
    color: #636363;
    font-size: 16px;
    line-height: 22px;
  }
  .out-of-loans-container {
    display: flex;
    flex-direction: column;
    .out-of-loans-content {
      order: 1;
    }
    .out-of-loans-icon {
      order: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: -32px;
      margin-bottom: 32px;
      img {
        width: 45px;
      }
    }
  }
  @media only screen and (min-width: 768px) {
    .out-of-loans-container {
      flex-direction: row;
      .out-of-loans-content {
        order: 0;
        flex: 1 0 300px;
        margin-right: 32px;
      }
      .out-of-loans-icon {
        order: 1;
        flex: 0 0 240px;
        margin: 0;
        img {
          width: auto;
        }
      }
    }
  }
</style>
<style lang="scss">
  .out-of-loans-modal {
    .modal-content {
      border-top: 10px solid #EC4C60;
      border-bottom: 10px solid #EC4C60;
    }
    .modal-header {
      border-bottom: 0;
    }
  }
  @media only screen and (min-width: 768px) {
    .out-of-loans-modal {
      .modal-body {
        padding: 12px 12px 32px 54px;
      }
    }
  }
  @media only screen and (min-width: 768px) and (max-width: 992px) {
    .out-of-loans-modal {
      .modal-dialog {
        max-width: 700px;
      }
    }
  }
</style>
